import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "sd_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-banner" className="fixed inset-x-0 bottom-0 z-[80] p-4 sm:p-6">
      <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-2xl border border-white/10 bg-navy-elevated/95 p-5 shadow-2xl backdrop-blur-xl sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <Cookie className="mt-0.5 h-5 w-5 flex-shrink-0 text-gold" strokeWidth={1.6} />
          <p className="text-sm text-slate-300">
            Nous utilisons des cookies nécessaires au fonctionnement du site et, avec votre accord, à la mesure d'audience.{" "}
            <Link to="/cookies" className="text-gold underline">En savoir plus</Link>.
          </p>
        </div>
        <div className="flex flex-shrink-0 gap-3">
          <button data-testid="cookie-refuse" onClick={() => decide("refused")}
            className="rounded-full border border-white/15 px-5 py-2 text-sm text-slate-200 hover:border-white/40">
            Refuser
          </button>
          <button data-testid="cookie-accept" onClick={() => decide("accepted")}
            className="rounded-full bg-gold px-5 py-2 text-sm font-semibold text-navy hover:bg-gold-light">
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
